import { type StateType } from '../../states';
import { type PreviousPagesState } from '../../states/previouspages';
import { type PreviousPosition } from '../../types/pages';
import { type Route } from '../../types/routes';
import { type Selector } from '../../types/selectors';
import { getRouteFromProps } from '../_propsGetters_';

const emptyObj = {};

export const selectPreviouspagesState: Selector<PreviousPagesState> = (state: StateType) =>
  state.previouspages ?? emptyObj;

type PreviouspagesSelectorProps = {
  route?: Route;
};

export const selectPreviouspagesEntity: Selector<PreviousPosition | undefined> = (
  state: StateType,
  props: PreviouspagesSelectorProps = {},
) => {
  const route = getRouteFromProps(state, props);

  if (route) {
    return selectPreviouspagesState(state)[route];
  }
};

export const selectPreviouspagesEntityPageNumber: Selector<number | undefined> = (
  state: StateType,
  props: PreviouspagesSelectorProps = {},
) => selectPreviouspagesEntity(state, props)?.pageNumber;

export const selectPreviouspagesEntityAnchorId: Selector<string | undefined> = (
  state: StateType,
  props: PreviouspagesSelectorProps = {},
) => selectPreviouspagesEntity(state, props)?.anchorId;
